import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import SystemNudgeCarousel from '../components/SystemNudgeCarousel';
import axios from 'axios';
import { useEffect } from 'react';
import { API_BASE_URL } from '../config';

// [Kullanım Kılavuzu] Mavi nudge carousel'in görünebileceği route'lar (systemNudgePages ile eşleşir).
// 'dashboard' YOK — onu OnboardingLanding kendi koşuluyla (onboarding nudge boşken) yönetir.
const NUDGE_PAGE_KEYS = new Set([
  'today-menu', 'my-kitchen', 'kitchen-planner', 'alakart-menu', 'diet-kitchen',
  'athlete-kitchen', 'allergen-kitchen', 'health-plus', 'special-days-kitchen',
  'my-shopping-lists', 'quick-search'
]);

const DashboardLayout = ({ children, isDarkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const nudgeKey = NUDGE_PAGE_KEYS.has(location.pathname.replace(/^\/+/, '')) ? location.pathname.replace(/^\/+/, '') : null;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [isAssistantChef, setIsAssistantChef] = useState(false);

  const toggleSidebar = () => setSidebarOpen(s => !s);

  useEffect(() => {
    const checkRole = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};
        const res = await axios.get(`${API_BASE_URL}/api/profile/status`, {
          headers,
          withCredentials: true
        });
        setIsAssistantChef(!!res.data.isAssistantChef);
      } catch (err) {
        if (err?.response?.status === 401) {
          localStorage.removeItem('authToken');
          navigate('/giris-yap', { replace: true });
          return;
        }
        console.error('Error checking role:', err);
      }
    };
    checkRole();
  }, [navigate]);

  return (
    <div className="relative flex h-auto min-h-screen w-full flex-col md:flex-row overflow-x-hidden bg-white dark:bg-[#1a1a1a] text-gray-900 dark:text-white transition-colors duration-200 antialiased">
      {!isAssistantChef && (
        <>
          <div onClick={toggleSidebar} className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-[150] transition-opacity duration-300 md:hidden ${sidebarOpen ? 'visible' : 'hidden'}`} />
          <Sidebar
            sidebarOpen={sidebarOpen}
            toggleSidebar={toggleSidebar}
            onStateChange={setIsSidebarExpanded}
          />
        </>
      )}

      <main className={`flex-1 flex flex-col transition-all duration-300 scroll-smooth pt-0 md:pt-24 ${!isAssistantChef ? 'md:ml-20' : ''}`}>
        <TopBar toggleSidebar={toggleSidebar} isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} showMenuButton={!isAssistantChef} isSidebarExpanded={isSidebarExpanded} />
        <div className={`flex-1 p-2 md:p-10 mx-auto flex flex-col gap-8 pb-12 w-full ${isAssistantChef ? 'max-w-5xl' : 'max-w-7xl'}`}>
          {nudgeKey && <SystemNudgeCarousel pageKey={nudgeKey} />}
          {children}
        </div>
        <Footer />
      </main>
    </div>
  );
};

export default DashboardLayout;
